/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 VxWishlist component.
 */
export class VxWishlist {
    constructor() {
        /**
         * Click event handle function.
         */
        this.addToWishlist = () => {
            this.productOnWishlist = !this.productOnWishlist;
            this.addToWishlistClicked.emit({ active: this.productOnWishlist });
        };
        this.productOnWishlist = true;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render() {
        return (h(Host, { key: 'c029c5bceab0bfac4ec829f9222f2ba28e21f8c2' }, h("button", { key: '2b6f63da055637f7e9cc36ee96c93e25944c4231', role: "button", class: "wishlist-button", "aria-label": "Produkt der Wishlist hinzuf\u00FCgen", onClick: this.addToWishlist }, this.productOnWishlist && (h("svg", { class: "wishlist-icon", xmlns: "http://www.w3.org/2000/svg", height: "24", viewBox: "0 0 24 24", width: "24" }, h("path", { d: "M0 0h24v24H0z", fill: "none" }), h("path", { d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28\n                                2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81\n                                4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58\n                                3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55\n                                11.54L12 21.35z" }))), !this.productOnWishlist && (h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24", viewBox: "0 0 24 24", width: "24" }, h("path", { d: "M0 0h24v24H0z", fill: "none" }), h("path", { d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91\n                                3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0\n                                3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6\n                                15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4\n                                15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5\n                                5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99\n                                14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14\n                                5.74-7.9 10.05z" }))))));
    }
    static get is() { return "vx-wishlist"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-wishlist.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-wishlist.css"]
        };
    }
    static get properties() {
        return {
            "productOnWishlist": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Describes whether product is on wishlist or not."
                },
                "attribute": "product-on-wishlist",
                "reflect": false,
                "defaultValue": "true"
            }
        };
    }
    static get events() {
        return [{
                "method": "addToWishlistClicked",
                "name": "addToWishlistClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event 'addToWishlistClicked' to emit to parent."
                },
                "complexType": {
                    "original": "object",
                    "resolved": "object",
                    "references": {}
                }
            }];
    }
}
//# sourceMappingURL=vx-wishlist.js.map
